import { connect, MapStateToProps } from 'react-redux';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { AppState } from '../../../../types/store';
import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import { Props } from './CustomBox';

type StateProps = Pick<
  Props,
  | 'moduleVersion'
  | 'image'
  | 'customtext'
  | 'backgroundType'
  | 'imageDisplayMode'
  | 'imageTint'
  | 'pattern'
  | 'gradient'
  | 'color'
  | 'isCurrentUserCoreMember'
>;

type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleVersion = getModuleVersion(state, ownProps.moduleId);
  const moduleData = getModuleData(state, ownProps.moduleId);
  const image = getDeviationById(state, moduleData.image);
  const isCurrentUserCoreMember = getCurrentUserHasCore(state);
  return {
    ...moduleData,
    moduleVersion,
    image,
    color: moduleData.color,
    isCurrentUserCoreMember,
  };
};

export default connect(mapStateToProps);
